import { Component, Input } from '@angular/core';
import { UsageWarnings, Probability } from '../../types';

@Component({
  selector: 'usage-warnings',
  templateUrl: 'usage-warnings.html'
})
export class UsageWarningsComponent {

  @Input()
  usageWarnings: UsageWarnings;
  @Input()
  probability: Probability;
}



// WEBPACK FOOTER //
// ./src/components/usage-warnings/usage-warnings.ts